import { Link } from '@tanstack/react-router'
import { Compass } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Logo } from '@/components/logo'

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <Link to="/" className="mb-10">
        <Logo />
      </Link>

      <span className="flex size-16 items-center justify-center rounded-2xl bg-brand-soft text-brand">
        <Compass className="size-8" />
      </span>

      <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-ink">Halaman tidak ditemukan</h1>
      <p className="mt-2 max-w-md text-muted">
        Tautan mungkin sudah berubah, atau halaman ini memang tidak pernah ada. Mari kembali ke jalur yang
        benar.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/">
          <Button size="lg">Kembali ke beranda</Button>
        </Link>
        <Link to="/kelas">
          <Button size="lg" variant="outline">
            Lihat katalog kelas
          </Button>
        </Link>
      </div>
    </div>
  )
}
